// extracted by mini-css-extract-plugin
module.exports = {"UGC":"UGC_UGC__hyQFp"};